import { CSSProperties } from 'react';
import { EnquiryHeaderComponent } from './enquiry-header.component';
import { EnquiryMainContainerComponent } from './enquiry-main-container.component';
import { useEnquiryContext } from '@vivli/features/enquiry/infastructure/context';
import { LoadIndicatorCenteredView } from '@vivli/shared/views';
import { EnquiryDataInfoRequestsComponent } from './enquiry-data-info-requests.component';

const containerStyle: CSSProperties = {
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    height: '100%'
};

const enquiryContainerStyle: CSSProperties = {
    padding: '20px',
    height: '100%',
    width: '100%',
    overflowX: 'auto'
};

const dirMainContainer: CSSProperties = {
    minHeight: '400px',
    marginTop: '40px'
};

export const EnquiryComponent = () => {
    const { pageEndRef, isLoading } = useEnquiryContext();

    return (
        <>
            {isLoading && <LoadIndicatorCenteredView />}
            <div style={containerStyle}>
                <EnquiryHeaderComponent />
                <div style={enquiryContainerStyle} className="scrolly">
                    <EnquiryMainContainerComponent />
                    <div style={dirMainContainer}>
                        <EnquiryDataInfoRequestsComponent />
                    </div>
                    <div ref={pageEndRef}></div>
                </div>
            </div>
        </>
    );
};
